module.exports = __webpack_public_path__ + "files/d5e0f00c53ed07c71009edbe0969ea6a.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/exo2-bolditalic-webfont.woff
// module id = 672
// module chunks = 60